import { FC } from "react";
import { Navigate } from "react-router";
import { useSuperAdmin } from "../hooks/useSuperAdmin";

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

const SuperAdminRoute: FC<SuperAdminRouteProps> = ({ children }) => {
  const { isSuperAdmin, isChecking } = useSuperAdmin();

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-950 to-black">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
      </div>
    );
  }

  return isSuperAdmin ? <>{children}</> : <Navigate to="/" replace />;
};

export default SuperAdminRoute;
